import { RG_TYPE, checkRequiredSpaces, SpacesList } from "@project-rouge/rg-core";
import { getRgObjectsOfType, getBuildingAttributes } from "@project-rouge/rg-three";
import { isBuildingEmpty } from "./index187.js";
import { addTechnicalSpaces } from "./index58.js";
import { getActiveZones } from "./index186.js";
const pipeAddTechSpaces = ([parent, {
  aggProps,
  techData = [],
  buildingIds
}]) => {
  const dataset = aggProps.dataset;
  const zones = getActiveZones(parent, aggProps);
  for (const zone of zones) {
    const aggZoneProps = aggProps.zones[zone.uuid];
    const buildings = getRgObjectsOfType(zone, RG_TYPE.Building);
    for (const building of buildings) {
      if (buildingIds && !buildingIds.includes(building.uuid))
        continue;
      if (isBuildingEmpty(building))
        continue;
      const buildingAttributeProps = {
        LevelHeight: dataset.aggConfig.f2fHeight,
        PodiumHeight: aggZoneProps.podium ? aggZoneProps.podium.height : 0,
        MaxModuleDepth: dataset.aggConfig.moduleDepth
      };
      const buildingAttributes = getBuildingAttributes(building, buildingAttributeProps, aggZoneProps.techSpaces.userDefinedAttributes);
      const forceInvalid = aggZoneProps.techSpaces.forceInvalid !== void 0 ? aggZoneProps.techSpaces.forceInvalid : true;
      const requiredSpaces = checkRequiredSpaces(buildingAttributes, SpacesList, aggZoneProps.techSpaces.optionalSpaces);
      const { consolidated, spacesAdded, invalid } = addTechnicalSpaces({ building, buildingAttributes, requiredSpaces, forceInvalid, podiumProps: aggZoneProps.podium, dataset });
      techData.push({
        buildingID: building.uuid,
        spacesRequired: requiredSpaces,
        spacesAdded,
        spacesConsolidated: consolidated,
        errors: invalid
      });
    }
  }
  return [parent, void 0];
};
export {
  pipeAddTechSpaces
};
//# sourceMappingURL=index97.js.map
